import { Component } from 'react';
import PropTypes from 'prop-types';
import DownwardsArrowComponent from '../../shared_components/DownwardsArrowComponent';

/* Specific component for rows that match a risk class reduction year */
class TableRowSubRiskClassReductionComponent extends Component {
  render() {
    const { row } = this.props;

    return (
      <tr>
        <td className="calculation-container__loanpart-overview__sub-risk-class-reduction">Korting</td>
        <td className="calculation-container__loanpart-overview__sub-risk-class-reduction" />
        <td className="calculation-container__loanpart-overview__sub-risk-class-reduction">
          <DownwardsArrowComponent classNames="arrow" />
          {row.interestDiscount}
        </td>
        <td className="calculation-container__loanpart-overview__sub-risk-class-reduction" />
        <td className="calculation-container__loanpart-overview__sub-risk-class-reduction" />
        <td className="calculation-container__loanpart-overview__sub-risk-class-reduction">
          <DownwardsArrowComponent classNames="arrow" />
          {row.monthlyPaymentDiscount}
        </td>
      </tr>
    );
  }
}

TableRowSubRiskClassReductionComponent.propTypes = {
  row: PropTypes.shape({}),
};

TableRowSubRiskClassReductionComponent.defaultProps = {
  row: {},
};

export default TableRowSubRiskClassReductionComponent;
